import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { RequiredInput } from './input'
import { Choice, ChoicePicker } from './choice-picker'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  paper: {
    margin: '15px',
    padding: '15px'
  }
})

export type Nurse = {
  name: string;
  choice: Choice;
}

export interface NurseFormProps {
  value: Nurse;
  onChange: (value: Nurse) => void;
  showError?: boolean;
  onErrorChange: (value: boolean) => void;
  disabled?: boolean;
}

export const NurseForm: React.FC<NurseFormProps> = function (props) {
  const styles = useStyles()
  const { value: nurse, onChange, showError = false, onErrorChange, disabled = false } = props

  const [nameError, setNameError] = useState(false)

  function validate (nurse: Nurse) {
    setNameError(!nurse.name)
    let tempErr = false
    if (nurse.choice.choiceThisYear === 'Po raz kolejny' && nurse.choice.reasonOfChange) {
      const reason = nurse.choice.reasonOfChange
      tempErr = Number(reason.home) + Number(reason.other) + Number(reason.otherFromchoice ? Math.min((reason.lawReason || '').length, 1): false) + Number(reason.serviceStopped) + Number(reason.becameAdult) !== 1
    }

    onErrorChange(!nurse.name || !nurse.choice.choiceThisYear || tempErr)
  }

  function update (key: string, value: any) {
    const n ={
      ...nurse,
      [key]: value
    }
    validate(n)
    onChange(n)
  }

  return (
    <Paper className={styles.paper}>
      <Typography variant="h6">Dane dotyczące położnej podstawowej opieki zdrowotnej.</Typography>
      <Grid container direction="column">
        <Grid item xs>
          <RequiredInput disabled error={showError && nameError} value={nurse.name} onChange={value => update('name', value)} label="Imię i nazwisko położnej podstawowej opieki zdrowotnej" />
        </Grid>
        <Grid item xs>
          <ChoicePicker value={nurse.choice} showError={showError} onErrorChange={() => {}} onChange={value => update('choice', value)} />
        </Grid>
      </Grid>
    </Paper>
  )
}
